import { render, staticRenderFns } from "./TranProgramCreate.vue?vue&type=template&id=c8e183e6"
import script from "./TranProgramCreate.vue?vue&type=script&lang=js"
export * from "./TranProgramCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports